import { createV4bClient } from "@/data/api/v4b/v4b-client";
import { V4bClientSdk } from "@/data/api/v4b/v4b-client-sdk";
import { Env } from "@/utils/env-schema";

export interface IServices {
  // Global
  env: Env;

  // V4b-backend (/ Kili)
  v4b: {
    clientSdk: V4bClientSdk;
  };
}

export function createServices(params: { env: Env }): IServices {
  const { env } = params;

  const v4bClient = createV4bClient(env);
  const v4bClientSdk = V4bClientSdk(v4bClient);

  return {
    // Global
    env,

    // V4b-backend
    v4b: {
      clientSdk: v4bClientSdk,
    },
  };
}
